require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-vice-president-of-communications.json") })
        }
      }, "path---articles-tags-vice-president-of-communications");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-vice-president-of-communications!./.cache/json/articles-tags-vice-president-of-communications.json
// module id = 1951
// module chunks = 231608221292675